import Application from 'components/Application';
import Contact from 'components/Contact';
import Func from 'components/Func';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import React from 'react';

const FuncPage = () => {
  return (
    <Layout>
      <SEO title='comachicart' path='func' />
      <Func />
      <Contact />
      <Application />
    </Layout>
  );
};

export default FuncPage;
